import axios from 'axios'
import Cookies from 'js-cookie'
import {STORE_APP_MUTATION_TYPES} from '../libs/constants'

let util = {}

// 浏览器存储类型,cookies / local storage
const browserStoreType = 'cookies'
// 默认打开的菜单的routerName，匹配不到则不会打开
const defaultMenuRouterName = 'dashboard'
// 是否启用websocket
const enableWebSocket = false

// 后端地址配置
const wsServerName = 'ws.webtrn.cn'
const apiServerName = document.domain
const apiPort = process.env.apiPort
const apiContextPath = ''
const apiBasePath = apiServerName + ':' + apiPort + apiContextPath
const baseUrl = 'http://' + apiBasePath
const wsBaseUrl = wsServerName + ':' + apiPort + apiContextPath

util.defaultMenuRouterName = defaultMenuRouterName
util.enableWebSocket = enableWebSocket
util.wsBaseUrl = wsBaseUrl
util.apiBasePath = apiBasePath
util.baseUrl = baseUrl
util.ajax = axios.create({
  baseURL: baseUrl,
  timeout: 30000,
  withCredentials: true // 请求时是否携带cookies (同时决定是否会根据response设置cookies)
})
util.ajax.interceptors.request.use(function (config) {
  config.headers.common['Authorization'] = util.bearerToken()
  return config
})
util.ajax.interceptors.response.use(
  (resp) => {
    return resp
  },
  (error) => {
    if (error.response && error.response.status === 401 && util.token()) {
      util.removeLocalStore('token')
      util.removeLocalStore('user')
      window.location.reload()
    }
    return Promise.reject(error)
  }
)

util.getClientIdByDomain = function () {
  return document.domain
}

util.logout = function () {
  util.ajax.post('/logout').then((res) => {
    // 不管后端清除token是否成功,前端都进行退出操作
    util.removeUserInfo()
    window.location.reload()
  }).catch((err) => {
    util.removeUserInfo()
    window.location.reload()
    console.warn('退出失败')
    console.error(err)
  })
}

util.removeUserInfo = function () {
  util.removeLocalStore('token')
  util.removeLocalStore('user')
  util.removeLocalStore('role')
}

util.supportLocalStorage = function () {
  try {
    localStorage.setItem('test', 1)
    localStorage.removeItem('test')
    return true
  } catch (e) {
    return false
  }
}

util.setLocalStore = function (name, value) {
  if (browserStoreType === 'localStorage' && util.supportLocalStorage()) {
    localStorage.setItem(name, value)
  } else if (browserStoreType === 'cookies') {
    Cookies.set(name, value)
  }
}

util.getLocalStore = function (name) {
  if (browserStoreType === 'localStorage' && util.supportLocalStorage()) {
    return localStorage.getItem(name)
  } else if (browserStoreType === 'cookies') {
    return Cookies.get(name)
  }
}

util.removeLocalStore = function (name) {
  if (browserStoreType === 'localStorage' && util.supportLocalStorage()) {
    localStorage.setItem(name, '')
  } else if (browserStoreType === 'cookies') {
    Cookies.remove(name)
  }
}

util.token = function (token) {
  if (token) {
    util.setLocalStore('token', token)
  } else {
    return util.getLocalStore('token') || ''
  }
}

util.bearerToken = function () {
  return (util.token() !== '' ? 'bearer ' + util.token() : '')
}

util.user = function (userData) {
  if (userData) {
    util.setLocalStore('user', userData)
  } else {
    let user = util.getLocalStore('user')
    return user || ''
  }
}

util.userRoleTypeCode = function (data) {
  if (data) {
    util.setLocalStore('role', data)
  } else {
    let role = util.getLocalStore('role')
    return role || ''
  }
}

/**
 * 异步加载下拉框数据
 * @param url 数据获取地址
 * @param dataIndex
 * @param element 触发该方法的input，如果element存在会使用element的placeholder显示“数据加载中...”
 * @param selectDataContainer 下拉框数据获取以后存放的容器，map结构，dataIndex作为key
 * @param vm Vue实例，主要使用其中的$set()方法
 */
util.loadSelectData = function (url, dataIndex, element, selectDataContainer, vm, cParams) {
  let ph = element ? element.placeholder : ''
  if (element) {
    element.placeholder = '请稍等，数据加载中...'
  }
  if (!cParams) {
    cParams = {}
  }
  cParams.columnDataIndex = dataIndex
  let params = {params: cParams}
  util.ajax.post(url, params).then((res) => {
    if (res.data.meta.errCode === 0) {
      vm.$set(selectDataContainer, dataIndex, res.data.data)
    }
    if (element) {
      element.placeholder = ph
    }
  }).catch((err) => {
    console.warn('获取下拉框数据失败: ' + dataIndex)
    console.error(err)
    if (element) {
      element.placeholder = ph
    }
  })
}

util.isArray = function (o) {
  return Object.prototype.toString.call(o) === '[object Array]'
}

util.formatDate = function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (('00' + str).substr(str.length)))
    }
  }
  return fmt
}

util.loadIframe = function (url) {
  document.getElementById('mainContent').src = url
}

util.getAttribute = function (obj, key, col) {
  let val = ''
  if (!obj) {
    val = ''
  } else if (obj[key]) {
    val = obj[key]
  } else if (key.toLowerCase().startsWith('combobox')) {
    val = obj[key.substring(key.lastIndexOf('.') + 1)]
  } else {
    while (key.indexOf('.') !== -1) {
      obj = obj[key.substring(0, key.indexOf('.'))]
      key = key.substring(key.indexOf('.') + 1)
    }
    val = obj[key]
  }
  if (col && (col.type === 'datetime' || col.type === 'date') && val) {
    let format = col.format || 'yyyy-MM-dd'
    val = util.formatDate(new Date(val), format)
  }
  if (col && col.defaultText && !val) {
    return col.defaultText
  }
  return val
}

util.compile = function (template) {
  const evalExpr = /<%=(.+?)%>/g
  const expr = /<%([\s\S]+?)%>/g

  template = template
    .replace(evalExpr, '`); \n  echo( $1 ); \n  echo(`')
    .replace(expr, '`); \n $1 \n  echo(`')

  template = 'echo(`' + template + '`);'

  let script =
    `(function parse(data){
    let output = "";

    function echo(html){
      output += html;
    }

    ${template}

    return output;
  })`

  return script
}

util.convertJsonToForm = function(data, map, k, vm) { // 将json数据转换成表单数据格式，例如：peRoleType:{name:'学生'} 转换为peRoleType.name : '学生'
  for (let key in data) {
    if (typeof (data[key]) === 'object') {
      this.convertJsonToForm(data[key], map, k + key + '_', vm)
    } else {
      vm.$set(map, k + key, data[key])
    }
  }
}

util.convertFormToJson = function(value, map, key, vm) { //  将表单数据格式转换成json数据，例如：peRoleType.name : '学生' 转换为 peRoleType:{name:'学生'}
  let keys = key.split('_')
  if (keys.length > 1) {
    let children = {}
    if (map[keys[0]]) {
      children = map[keys[0]]
    }
    vm.$set(map, keys[0], children)
    let childrenKey = key.substr(key.indexOf('_') + 1, key.length)
    this.convertFormToJson(value, children, childrenKey, vm)
  } else {
    vm.$set(map, key, value)
  }
}

util.fileDown = function (downUrl, fileDownPath, title) { // 封装form表单下载文件
  var tempform = document.createElement('form')
  tempform.action = downUrl
  tempform.method = 'post'
  tempform.style.display = 'none'
  tempform.target = '_blank'
  var opt = document.createElement('input')
  opt.name = 'access_token'
  opt.value = util.token()
  tempform.appendChild(opt)
  opt = document.createElement('input')
  opt.name = 'fileDownPath'
  opt.value = fileDownPath
  tempform.appendChild(opt)
  opt = document.createElement('input')
  opt.name = 'fileName'
  opt.value = title
  tempform.appendChild(opt)
  opt = document.createElement('input')
  opt.type = 'submit'
  tempform.appendChild(opt)
  document.body.appendChild(tempform)
  tempform.submit()
  document.body.removeChild(tempform)
}

/**
 * 创建form表单，并提交；
 * 默认target='_blank'
 * @param url        提交地址
 * @param parameters 参数
 * @param withToken 是否携带token
 */
util.useFormSubmit = function (url, parameters, withToken) {
  var form = document.createElement('form')
  form.action = url
  form.method = 'post'
  form.style.display = 'none'
  form.target = '_blank'
  if (parameters) {
    for (let key in parameters) {
      let input = document.createElement('input')
      input.name = key
      input.value = parameters[key]
      form.appendChild(input)
    }
  }
  if (withToken) {
    let input = document.createElement('input')
    input.name = 'access_token'
    input.value = util.token()
    form.appendChild(input)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

util.changeRouter = function (vm, router) {
  vm.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_FORWARD, router)
  vm.$router.push(router)
}

util.routerBack = function (vm, routerName) {
  vm.$store.commit(STORE_APP_MUTATION_TYPES.UPDATE_CURRENT_ROUTES_BACK, {routerName: routerName})
  vm.$store.commit(STORE_APP_MUTATION_TYPES.REMOVE_CACHED_VIEWS, {id:routerName})
  const toRoute = util.getDestRouter(vm.$store.state.app.currentTab)
  // 添加返回标志位
  if (toRoute.params) {
    toRoute.params.isBack = true
  } else {
    toRoute.params = {isBack: true}
  }
  vm.$router.push(toRoute)
}

util.getDestRouter = function (tab) {
  let dest = {name: tab.id}
  const routers = tab.routers
  if (routers && routers.length > 0) {
    dest = routers[routers.length - 1]
  }
  return dest
}

util.pushAll = function (arr1, arr2, distinct) {
  if (!arr1 || !arr2) {
    return
  }
  for (let i = 0; i < arr2.length; i++) {
    if (!distinct || !arr1.includes(arr2[i])) {
      arr1.push(arr2[i])
    }
  }
}

util.removeAll = function (arr1, arr2) {
  if (!arr1 || !arr2) {
    return
  }
  let i = arr1.length
  while (i--) {
    for (let j = 0; j < arr2.length; j++) {
      if (arr1[i] === arr2[j]) {
        arr1.splice(i, 1)
      }
    }
  }
}

// 获取文本显示时的宽度
util.getTextDisplayWidth = function (text, fontSize) {
  let span = document.getElementById('hidden-get-text-width')
  if (span == null) {
    span = document.createElement('span')
    span.id = 'hidden-get-text-width'

    document.body.appendChild(span)
    span.style.visibility = 'hidden'
    span.style.height = '0px'
    span.style.whiteSpace = 'nowrap'
    span.style.position = 'absolute'
    span.style.zIndex = '-100'
  }
  span.innerText = text
  span.style.fontSize = fontSize + 'px'
  let width = span.offsetWidth
  span.innerText = ''
  return width
}

// 监听浏览器回退按钮
util.detectBack = function (vm) {
  if (history.pushState) { // 现代浏览器
    window.onpopstate = function() {
      util.routerBack(vm)
    }
  } else {                  // ie9及以下
    // $(window).on('hashchange', function() {
    //     if(location.hash=="#foo"){
    //         return
    //     }
    //     // logout()
    // })
  }
}

// 替换掉html标签
util.clearHtml = function (html) {
  return html ? html.replace(/<[^>]*>|/g, '') : ''
}

// 替换html为转义符
util.html2Escape = function (sHtml) {
  return sHtml.replace(/[<>&"]/g, function (c) {
    return {'<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;'}[c]
  })
}

// indexOf 不区分大小写

util.indexOfIgnoreCase = function (testStr, subStr) {
  return testStr.toLowerCase().indexOf(subStr.toLowerCase())
}

util.oneOf = function (value, validList) {
  for (let i = 0; i < validList.length; i++) {
    if (value === validList[i]) {
      return true
    }
  }
  return false
}

export default util



// WEBPACK FOOTER //
// ./src/libs/util.js